<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content">
                <div class="movie_area">
                    <div class="inner ptb80">
                        <p>
                            <!-- embedurl 있으면 영상 -->
                            <iframe
                                v-if="youtube.embedurl"
                                :src="youtube.embedurl"
                                width="100%"
                                height="480"
                                frameborder="0"
                                allowfullscreen
                            ></iframe>

                            <!-- 없으면 썸네일 -->
                            <img
                                v-else
                                :src="youtube.thumbpath || require('@/assets/mainimg1.jpg')"
                                alt=""
                            >
                        </p>
                    </div>
                </div>
                <div class="list inner">
                    <div class="movie_list mtb80">
                      <h2>Post (Recent 5 posts)</h2>   
                      <div class="list_box lst">
                        <div class="list" v-for="(post, index) in blog" :key="index">
                          <a :href="post.url" target="_blank">
                            <div class="row">    
                              <div class="img">
                                <img :src="baseUrl + post.img" alt="">
                              </div>
                              <div class="txt">
                                <span class="state blue_f bluee_bg">Blog Post</span>
                                <h3>{{ post.title }}</h3>
                                <span class="date">{{ formatDate(post.timecreated) }}</span>
                              </div>
                            </div>
                          </a>
                          <hr v-if="index < blog.length - 1">
                        </div>
                      </div>
                   </div>
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>

<script>
import api from '@/api'
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'

export default {
    name: 'OnlineSeminar',
    components: {
        TheHeader,
        TheFooter
    },

    data() {
        return {
            youtube: {
                embedurl: null,
                thumbpath: null
            },
            blog: [],
            baseUrl: api.defaults.baseURL // API base URL
        }
    },

    mounted() {
        this.loadMainYoutube()
    },

    methods: {
        /* 대표 유튜브 영상 로드 */
        async loadMainYoutube() {
            try {
                const res = await api.get('/admin/get_youtube')

                if (res.data && res.data.data) {
                    this.youtube = res.data.data.youtube || { embedurl: null, thumbpath: null }
                    this.blog    = res.data.data.blog || []
                }
            } catch (e) {
                console.error('대표 영상 로딩 실패', e)
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return ''

            // "2025-08-19 00:00:00.000" → "2025-08-19"
            return dateStr.substring(0, 10)
        }
    }
}
</script>